import { DeleteAssigneeContainer } from './DeleteAssignee.container'

type DeleteAssigneeIdWrapperProps = {
  setIsRequestRunning: (params: boolean) => void
  id?: string
  visible: boolean
  onHide: () => void
  mutate: () => void
}

export const DeleteAssigneeIdWrapper: React.FC<
  DeleteAssigneeIdWrapperProps
> = ({ id, mutate, setIsRequestRunning, onHide, visible }) => {
  if (!id) return null
  return (
    <DeleteAssigneeContainer
      setIsRequestRunning={setIsRequestRunning}
      id={id}
      visible={visible}
      onHide={onHide}
      mutate={mutate}
    />
  )
}
